<template>
    <el-dialog title="选择用户" :visible.sync="visible" :close-on-click-modal="false" append-to-body width="720px"
        top="48px" @closed="$emit('input',false)">
        <el-row :gutter="8">
            <el-col :span="12" style="line-height: 28px;">组织机构</el-col>
            <el-col :span="12" style="line-height: 28px;">用户</el-col>
        </el-row>
        <el-row :gutter="8" style="margin-top: 5px;">
            <el-col :span="12">
                <div class="narrow-scrollbar border rounded overflow-auto" style="height: 480px;">
                    <el-tree ref="organizationTree" :data="organizationTreeNodes" node-key="id" highlight-current
                        default-expand-all :expand-on-click-node="false" @current-change="selectOrganizationTreeNode" />
                </div>
            </el-col>
            <el-col :span="12">
                <el-input v-model="key" clearable size="medium" placeholder="搜索" />
                <div class="narrow-scrollbar border rounded overflow-auto" style="height: 439px; margin-top: 5px;">
                    <el-table :data="filteredUsers" :show-header="false">
                        <el-table-column>
                            <template #default="scope">
                                <div :title="scope.row.organizationName">
                                    {{scope.row.name}}
                                    <span class="text-info">{{scope.row.userName}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="80" align="right">
                            <template #default="scope">
                                <el-button type="primary" size="small" @click="selectUser(scope.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
        </el-row>
        <template #footer>
            <el-checkbox v-model="cascade" class="float-left" style="line-height: 40px;">级联</el-checkbox>
            <el-button @click="$emit('input',false)">取消</el-button>
        </template>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            value: { type: Boolean, default: false },
            defaultCascade: { type: Boolean, default: false },
        },
        data() {
            return {
                visible: this.value,
                cascade: this.defaultCascade,
                organizationTreeNodes: [],
                organizationId: '',
                organizationName: '',
                key: null,
                users: [],
            };
        },
        computed: {
            filteredUsers() {
                if (this.key) {
                    return this.users.filter(p => p.userName.indexOf(this.key) != -1 || p.name.indexOf(this.key) != -1);
                }
                else {
                    if (this.cascade) {
                        return this.users.filter(p => p.organizationId.substr(0, this.organizationId.length) == this.organizationId);
                    }
                    else {
                        return this.users.filter(p => p.organizationId == this.organizationId);
                    }
                }
            },
        },
        watch: {
            value(value) {
                this.visible = value;
                if (value) {
                    this.loadOrganizationTreeNodes();
                    this.loadUsers();
                }
            },
        },
        methods: {
            async loadOrganizationTreeNodes() {
                let response = await this.$axios.get('/api/Organization/GetOrganizationTreeNodes');
                this.organizationTreeNodes = response.data;
                if (response.data.length > 0) {
                    this.$nextTick(() => {
                        this.$refs.organizationTree.setCurrentKey(response.data[0].id);
                        this.selectOrganizationTreeNode(response.data[0]);
                    });
                }
            },
            selectOrganizationTreeNode(data) {
                this.key = null;
                this.organizationId = data.id;
                this.organizationName = data.label;
            },
            async loadUsers() {
                let response = await this.$axios.get('/api/User/GetUsers');
                this.users = response.data;
            },
            selectUser(user) {
                this.$emit('select', user);
                this.$emit('input', false);
            },
        },
    };
</script>